import { useState, useMemo } from "react";

export const useWeekNavigation = () => {
	const [weekOffset, setWeekOffset] = useState(0);

	const getMonday = (date) => {
		const d = new Date(date);
		const day = d.getDay() || 7;
		if (day !== 1) {
			d.setDate(d.getDate() - day + 1);
		}
		return d;
	};

	const today = new Date();
	const currentMonday = getMonday(today);
	const selectedMonday = new Date(currentMonday);
	selectedMonday.setDate(currentMonday.getDate() + weekOffset * 7);

	const weekdays = useMemo(() => {
		const days = [];
		const dayNames = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];
		const shortDayNames = ["Mon", "Tue", "Wed", "Thu", "Fri"];

		for (let i = 0; i < 5; i++) {
			const dayDate = new Date(selectedMonday);
			dayDate.setDate(selectedMonday.getDate() + i);

			const dateFormatted = dayDate.toISOString().split("T")[0];

			days.push({
				name: dayNames[i],
				shortName: shortDayNames[i],
				date: dayDate,
				dateFormatted,
				periodCount: i === 4 ? 5 : 7,
				isToday: dayDate.toDateString() === today.toDateString(),
			});
		}
		return days;
	}, [selectedMonday, today]);

	const navigateToPreviousWeek = () => setWeekOffset((prev) => prev - 1);
	const navigateToNextWeek = () => {
		if (weekOffset < 0) setWeekOffset((prev) => prev + 1);
	};
	const navigateToCurrentWeek = () => setWeekOffset(0);

	const formatWeekRange = () => {
		const startDate = new Date(selectedMonday);
		const endDate = new Date(selectedMonday);
		endDate.setDate(startDate.getDate() + 4);

		const options = { month: "short", day: "numeric" };
		return `${startDate.toLocaleDateString(
			"en-US",
			options
		)} - ${endDate.toLocaleDateString("en-US", options)}${
			weekOffset === 0 ? " (Current Week)" : ""
		}`;
	};

	return {
		weekdays,
		weekOffset,
		navigateToPreviousWeek,
		navigateToNextWeek,
		navigateToCurrentWeek,
		formatWeekRange,
		isCurrentWeek: weekOffset === 0,
		canNavigateNext: weekOffset < 0,
	};
};
